import * as t from "io-ts";

export const RepeaterFieldV = t.type({
  field: t.string,
  index: t.number
});

export const TemplatePreviewableItemV = t.type({
  label: t.string,
  url: t.string,
  type: t.string,
  repeater: t.union([RepeaterFieldV, t.null, t.undefined])
});

export const TemplatePreviewableItemsV = t.array(TemplatePreviewableItemV);

export type TemplatePreviewableItem = t.TypeOf<typeof TemplatePreviewableItemV>;

export const TemplatePreviewV = t.type({
  previewableItems: t.union([TemplatePreviewableItemsV, t.literal(false)]),
  lastPreviewedItem: t.union([TemplatePreviewableItemV, t.literal(false)])
});

export type TemplatePreview = t.TypeOf<typeof TemplatePreviewV>;
